import { useExperimentsContext } from '../../../experiments/components/ExperimentsContext'
import { experimentAccessorIsMarketplace } from '../../../experiments/model/experimentAccessor'
import { useGlobalConfigContext } from '../../../global-config'
import { type TENANT } from '../../../tenant'

type ProductPageContextData = {
  isMarketplace: boolean
  tenant: TENANT
}

export const useGetProductPageContextData = (): ProductPageContextData => {
  const globalConfig = useGlobalConfigContext()
  const { experiments } = useExperimentsContext()
  const isMarketplace = experimentAccessorIsMarketplace(
    experiments,
    globalConfig.tenant,
  )

  return {
    isMarketplace,
    tenant: globalConfig.tenant,
  }
}
